module.exports = __webpack_public_path__ + "static/Lato-Black-e631d2735799aa943d93d301abf423d2.ttf";